export function adminBasePath(): '/admin' | '/admin-dev' {
  return window.location.pathname.startsWith('/admin-dev/') ? '/admin-dev' : '/admin';
}
